import ValueX from '../types/ValueX';

export default class AllowedX extends ValueX {
    static __className = 'AllowedX';

    constructor(constructJson) {
        super(constructJson, 'allowed', 'AllowedX');
    }
}
